import { BaseState } from '@/store/base-state';
import {
  Analytics, Users, Organizations, Categories,
  OperatioTypes, RepairsTypes, Clients, AnalyticsFilters,
  CreditLineContract,
} from '../types';
import { default_analytics, default_filters } from '../services';

export default class AnalyticsState extends BaseState {
  analytics: Analytics.Section = default_analytics();
  response_filters: Analytics.Section = default_analytics();
  users: Users[] = [];
  organizations: Organizations[] = [];
  external_organization: string[] = [];
  categories: Categories[] = [];
  operation_types: OperatioTypes[] = [];
  repair_types: RepairsTypes[] = [];
  lead_regions: string[] = [];
  clients: Clients[] = [];
  order_side_numbers: string[] = [];
  years: string[] = [];
  credit_line_organization_ids: number[] = [];
  credit_line_contracts: CreditLineContract[] = [];

  orders_loading = false;
  certs_loading = false;
  returns_zip_loading = false;
  order_sides_loading = false;
  repair_models_loading = false;
  leads_loading = false;
  repair_types_loading = false;
  result_service_activity_loading = false;
  credit_line_loading = false;

  filters: AnalyticsFilters = default_filters()

  section = '';
}
